// Copyright (c) Bentley Systems
export class Style {
  public styleId: string | undefined;
  public data: string | undefined;
  public backgroundImageBase64Str: string | undefined;
  public customData: string | undefined;
}
